module.exports = __webpack_public_path__ + "static/media/ic_questionnaire.f88f51d1.png";